// SearchBlock.jsx
import React from 'react'
import { Search } from './Search'
import SelectComponent from '../SelectComponent'
import SortPanel from './SortPanel'
import { selectItemSearchProduct } from '../../store/localItems'

const SearchBlock = ({
    setSearchMainName,
    setSortSearch,
    productSort,
    sortSearch,
    sortType,
    search,
    get,
}) => {
    return (
        <SortPanel title="Поиск">
            <div className="disk__searchContainer">
                <Search
                    sortSearch={sortSearch}
                    search={search}
                    setSearchMainName={setSearchMainName}
                    sortType={sortType}
                    productSort={productSort && productSort}
                    get={get ? get : null}
                />
                <SelectComponent
                    title="Cортировка"
                    selectItem={selectItemSearchProduct}
                    value={sortSearch}
                    handleChange={(e) => setSortSearch(e.target.value)}
                    minWidth={250}
                />
            </div>
        </SortPanel>
    )
}

export default SearchBlock